import type { TError, TPostWithAuthor, TUpdatePost } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';
import { getAvailableTagsBaseQueryKey } from '../tags/get-available-tags';

export const useUpdateAdminPost = (postId: string) => {
  const queryClient = useQueryClient();

  return useMutation<TPostWithAuthor, TError, TUpdatePost>({
    mutationFn: async data => {
      const res = await axios.patch<TPostWithAuthor>(`/community-hub/admin/posts/${postId}`, data);
      return res.data;
    },
    onSuccess: updated => {
      // Refetch the admin lists this post might appear in.
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'admin', 'feed-posts'] });
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'admin', 'post', postId] });
      // Members feed lists also need to refresh (pin moves the post,
      // edit changes the body).
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'posts'] });
      // Edited tags can change which tags are "used", so refresh the filter list.
      queryClient.invalidateQueries({ queryKey: getAvailableTagsBaseQueryKey(updated.spaceId) });
    },
  });
};
